// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import type { CTABannerProps } from "./helsecoreCTABanner.d";
import { CTABanner } from "@dip/helsecore/src/components/parts/CTABanner/CTABanner";

export default (props: Readonly<CTABannerProps>) => <CTABanner {...props} />
